/* eslint no-undef: "off" */

import { BaseApi } from "../base.js";
// import { API } from "../constants.js";
const URL =
  globalThis?.import_meta_env?.VITE_API_ENDPOINT ||
  import.meta.env.VITE_API_ENDPOINT;

export class RewardsCentreApi extends BaseApi {
  async getRewardsStatus() {
    try {
      const request = await this.r.post(
        `${URL}/v1/loyalty/cabinet/activations`,
      );
      return request.data;
    } catch (error) {
      throw new Error(error, "getRewardsStatus error");
    }
  }

  async getAdventRewardsStatus() {
    try {
      const request = await this.r.post(`${URL}/v1/loyalty/cabinet/advent25`);
      return request.data;
    } catch (error) {
      throw new Error(error, "getAdventRewardsStatus error");
    }
  }
}
